import { Column } from "../CustomDataTable/CustomDataTable";
import { additionalFieldColumns, commonFieldColumns } from "./ContactCommonColumns";
import { FaCheckCircle } from "react-icons/fa";

// Define or import dynamicMenuAction
// const dynamicMenuAction = {
//   loyalty: true 
// };

 

export const CustomerColumns = (props: any): Column[] => [
  ...commonFieldColumns(props),
    {
    headerName: "Mobile No Status",
    renderCell: (params: any) =>
      params.row.isMobNoVerify === 0 ? "Un-Verified" : "Verified",
    field: "isMobNoVerify",
    width: 150,
    filtering: true,
    defaultChecked: false,
  },
{
  headerName: "Customer Segment",
  renderCell: (params: any) => {
    const totalSales = params.row.totalSales;

    if (totalSales >= -1 && totalSales <= 0) {
      return "Lost";
    } else if (totalSales >= 1 && totalSales <= 2) {
      return "Risk";
    } else if (totalSales >= 3 && totalSales <= 4) {
      return "Regular";
    } else if (totalSales >= 5 && totalSales <= 50000) {
      return "VIP";
    } else {
      return "";
    }
  },
  field: "totalSales",
  width: 150,
  filtering: true,
  defaultChecked: false,
},
  {
    field: "whatsAppNo",
    headerName: "Whatsapp No.",
    width: 150,
    filtering: false,
    defaultChecked: false,
    renderCell: (params: any) =>
    {
      const whatsAppNo = params.row.whatsAppNo;
       
      const prefix =
        params.row.countryDialCodePrefixWhatsapp == 0 
          ? "91"
          : params.row.countryDialCodePrefixWhatsapp;
    //  console.log("whatsAppNo",prefix)
      return whatsAppNo
        ? `+${prefix}-${whatsAppNo}`
        : "";
    }
  },
  {
    field: "avgBillValue",
    headerName: "Avg Bill Value",
    width: 150,
    defaultChecked: true,
    renderCell: (params: any) =>
      params.row.avgBillValue === ""
        ? "-"
        : params.row.avgBillValue.toFixed(props.sessionList?.decimalPoint || 2),
  },
  {
    field: "contactType",
    headerName: "Customer Type",
    width: 150,
    defaultChecked: false,
    filtering: true,
  },
  ...(props.dynamicMenuAction?.loyalty
    ? [
        {
          field: "loyaltyPoints",
          headerName: "Loyalty Point",
          width: 150,
          defaultChecked: true,
          renderCell: (params: any) =>
            params.row.loyaltyPoints?.toFixed(
              props.sessionList?.decimalPoint || 2
            ),
        },
      ]
    : []),
  // {
  //   field: "totalOutstandingCustomers",
  //   headerName: "Outstanding",
  //   width: 89,
  //   defaultChecked: true,
  //   renderCell: (params: any) =>
  //     params.row.totalOutstandingCustomers === ""
  //       ? "-"
  //       : params.row.totalOutstandingCustomers.toFixed(
  //           props.sessionList?.decimalPoint || 2
  //         ),
  // },
  ...(props.dynamicMenuAction?.membership === 1
    ? [
        {
          field: "membershipName",
          headerName: "Membership Type",
          width: 150,
          defaultChecked: false,
          filtering: true,
        },
      ]
    : []),
    {
      field: "active",
      renderCell: (params: any) => (
        <div
          style={{
            color: params.row.active === 0 ? "#00c700" : "#ababab",
          }}
        >
          <FaCheckCircle size={20} />
        </div>
      ),
      headerName: "Status",
      width: 70,
      defaultChecked: true,
      align: "center",
      filtering: true,
      isExisted: (params: any) =>
        params.row.active === 0 ? "Active" : "InActive",
    },
  ...additionalFieldColumns(props),
];